import { useEffect } from 'react';
import { throttle } from 'lodash';

interface UseHoverSlideParams {
    element: HTMLElement | null;
    onSlideChange?: (newSlideIndex: number) => void;
    slidesCount: number;
    isHoverType: boolean;
    isMobile: boolean;
}

export const useHoverSlide = ({
    slidesCount,
    element,
    onSlideChange,
    isHoverType,
    isMobile,
}: UseHoverSlideParams) => {
    useEffect(() => {
        if (!isHoverType || !element || isMobile) {
            return;
        }

        const elementLeft = element.getBoundingClientRect().left;

        const handleMouseMove = throttle((e: MouseEvent) => {
            const width = element.clientWidth;
            const clientX = e.clientX - elementLeft;
            let x = 0;

            if (clientX >= 0) {
                x = clientX > width ? width : clientX;
            }

            const step = width / slidesCount;
            let newSlideIndex: number = Math.floor(x / step);

            if (newSlideIndex >= slidesCount) {
                newSlideIndex -= 1;
            }

            onSlideChange?.(newSlideIndex);
        }, 100);

        element.addEventListener('mousemove', handleMouseMove);

        return () => {
            element.removeEventListener('mousemove', handleMouseMove);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slidesCount, element, isHoverType, onSlideChange]);
};
